import { StartPaymentFrontend } from './Types/dto/startPayment'
import { UserProductDTOFields } from './Types/dto/user/product'

// TODO: add type authUserProductAndPayment
export const calcTotalPrice = (
	startPaymentFrontend: StartPaymentFrontend,
	userProductDTO: UserProductDTOFields,
	authUserProductAndPayment?: any
): number => {
	let totalPriceInt = 0
	for (const adSubPageIdAndAdSubPageData of Object.entries(
		startPaymentFrontend?.adSubPagesData ?? {}
	)) {
		const [adSubPageId, adSubPageData] = adSubPageIdAndAdSubPageData
		const planId = adSubPageData.planId
		const paymentRecipients =
			userProductDTO?.adSubPages?.[
				adSubPageId ?? userProductDTO?.defaultPlanId ?? ''
			]?.plans?.[planId]?.paymentRecipients
		const authUserpaymentRecipients =
			authUserProductAndPayment?.product?.adSubPages?.[
				adSubPageId ?? userProductDTO?.defaultPlanId ?? ''
			]?.paymentRecipients
		const paymentRecipientIds = Object.keys(paymentRecipients ?? {})

		for (let i = 0; i < paymentRecipientIds.length; i++) {
			const paymentRecipientId = paymentRecipientIds[i]
			const paymentRecipient = paymentRecipients?.[paymentRecipientId]
			const authUserInvoiceSchemaItemGroup =
				authUserpaymentRecipients?.[paymentRecipientId]
			const products = paymentRecipient?.products
			const authUserproducts = authUserInvoiceSchemaItemGroup?.products
			const productIds = Object.keys(products ?? {})
			for (
				let productIdsInd = 0;
				productIdsInd < productIds.length;
				productIdsInd++
			) {
				const productId = productIds[productIdsInd]
				const product = products?.[productId]
				const unitPriceString =
					authUserproducts?.[productId].unitPrice ??
					products?.[productId].unitPrice
				if (product && unitPriceString) {
					const unitPriceNumber = parseInt(unitPriceString)
					if (!isNaN(unitPriceNumber)) {
						let quantity = 0
						let productFlexibleQuantity = 0
						if (product.invoiceItemQuantityType == 'flexible') {
							productFlexibleQuantity =
								startPaymentFrontend?.adSubPagesData[adSubPageId]
									?.productData?.[productId] ??
								product.defaultValue ??
								0
						}

						if (userProductDTO?.timeSelectionType == 'userSetTimeRange') {
							for (const eventTime of Object.values(
								adSubPageData.eventTimes ?? {}
							)) {
								if (!eventTime.endTime) {
									continue
								}
								const startTime = new Date(eventTime.startTime)
								const endTime = new Date(eventTime.endTime)
								const timeDifference = endTime.getTime() - startTime.getTime()
								const hoursDifference = timeDifference / (1000 * 60 * 60)
								quantity = quantity + hoursDifference * productFlexibleQuantity
							}
						} else if (product.quantity) {
							quantity =
								product.quantity *
								startPaymentFrontend?.adSubPagesData[adSubPageId].quantity
						} else if (productFlexibleQuantity) {
							quantity =
								productFlexibleQuantity *
								startPaymentFrontend?.adSubPagesData[adSubPageId].quantity
						}
						const ItemTotal = quantity * unitPriceNumber
						totalPriceInt += ItemTotal
					}
				}
			}
		}
	}
	return totalPriceInt
}
